var _excluded = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useMemo } from 'react';
import { getAutoCompleteProps } from '../../../../utils/form-field-utils';
export var useInputProps = _ref => {
  var {
    ref,
    getInputProps,
    disableClick,
    onClick,
    onKeyDown,
    closeMenu,
    isLoading
  } = _ref;

  // Based on https://github.com/downshift-js/downshift#customizing-handlers
  var handleKeyDown = event => {
    if (event.key === 'Enter') {
      if (isLoading) {
        // Prevent Downshift's default 'Enter' behavior.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore -- `preventDownshiftDefault` is a custom property from Downshift.
        event.nativeEvent.preventDownshiftDefault = true;
      } // Prevent sending the form when the menu is closed.


      event.preventDefault();
    } // Close the menu when the user tabs out of the input.


    if (event.key === 'Tab') closeMenu();
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  };

  var _getInputProps = getInputProps({
    ref,
    onKeyDown: handleKeyDown,
    // 'aria-labelledby' causes a11y issue because its value doesn't correspond to an element in the document.
    // The reason is because we use our own label (only when needed) using `FormField` wrapper instead of using `downshift`.
    'aria-labelledby': undefined
  }),
      {
    onClick: onInputClick
  } = _getInputProps,
      otherInputProps = _objectWithoutProperties(_getInputProps, _excluded);

  var handleClick = event => {
    if (disableClick) return;
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    onInputClick(event);
  };

  var autoCompleteProps = useMemo(() => getAutoCompleteProps(), []);
  return _objectSpread(_objectSpread({}, otherInputProps), {}, {
    onClick: handleClick
  }, autoCompleteProps);
};
//# sourceMappingURL=useInputProps.js.map